<template>
  <div class="main">
    <a-spin class="load"
            v-show="loading" />
    <div class="top">
      <div class="left">
        <div class="content"
             v-for="(item,index) in listData"
             :key="index">
          <div class="bgc">
            <div class="status">
              <span class="staTitle">状态</span>
              <span class="staMain">{{status}}</span>
            </div>
            <p class="message"> {{item.message}}</p>
          </div>
          <div class="fun">
            <div class="button">
              <a-button class="add"
                        @click="add"
                        icon="plus">添加</a-button>
              <a-button class="edit"
                        @click="edit(item)"
                        icon="form">编辑</a-button>
              <a-button class="delete"
                        @click="deleted(item.id)"
                        icon="delete">删除</a-button>
            </div>
            <!-- :disabled="disable==false" -->
          </div>
        </div>
      </div>
    </div>
    <!--add start-->
    <a-modal v-model="addVisible"
             title=""
             width="1000px"
             footer="">
      <div class="dalog">
        <div>
          <a-textarea class="mess"
                      v-model="addMessage"
                      :auto-size="{ minRows: 6, maxRows: 12 }" />
        </div>
        <div class="uploadImg">
          <a-select :default-value="format.viewPermission(addSelect)"
                    style="width:170px;"
                    @change="addSelectChange">
            <a-select-option v-for="(item, index) in selectOpen"
                             :key="index"
                             :value="item.key">
              {{item.value}}
            </a-select-option>
          </a-select>
          <a-button class="sureButton"
                    @click="addHandleOk">确定</a-button>
        </div>
      </div>
    </a-modal>
    <!--add end-->
    <!--edit start-->
    <a-modal v-model="editVisible"
             title=""
             width="1000px"
             footer="">
      <div class="editdalog">
        <div>
          <a-textarea @change="textChange"
                      class="mess"
                      v-model="editMess.message"
                      :auto-size="{ minRows: 6, maxRows: 12 }" />
        </div>
        <div class="uploadImg">
          <a-select style="width:170px;"
                    :default-value="format.viewPermission(editMess.viewPermission)"
                    @change="editSelectChange">
            <a-select-option v-for="(item, index) in selectOpen"
                             :key="index"
                             :value="item.key">
              <!-- {{format.viewPermission(editMess.viewPermission)}} -->
              {{item.value}}
            </a-select-option>
          </a-select>
          <a-button class="sureButton"
                    @click="editHandleOk">确定</a-button>
        </div>
      </div>
    </a-modal>
    <!--edit end-->
  </div>
</template>

<script>
// import HanIcon from 'components/Icon.vue'
import format from '../../../utils/format.js'
export default {
  name: 'TeachThink',
  components: {

  },
  created () {

  },
  data () {
    return {
      format,
      disable: false,
      loading: false,
      listData: [
        { message: '测试数据', viewPermission: 1, id: '1111' },
        { message: '测试数据1', viewPermission: 3, id: '2222' }
      ],
      defaultOpen: '公开',
      selectOpen: [{ value: '公开', key: '1' }, { value: '私密', key: '2' }, { value: '仅班级可见', key: '3' }],
      addVisible: false,
      editVisible: false,
      status: '公开',
      addValue: '',
      addMessage: '', // 添加信息
      addSelect: '1', // 添加类型
      editMess: '',//编辑信息对象
      editDefault: '',
      editMessage: '', //编辑信息详情
      editSelect: '', //编辑信息选择
      id: ''
    }
  },
  watch: {
    mlVisible () {

    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      const param = {
        bookId: localStorage.getItem('syzg-bookId'),
        styleId: localStorage.getItem('styleId'),
        teacherId: this.$getUserInfo().id,
        rangeType: '5',
        isPublish: '0'
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/chapter/getTeacherChapter',
        body: param
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          //
        }
      })
    },
    add () { // 新增弹窗
      this.addVisible = true
    },
    addSelectChange (val) { //新增权限选择
      this.addSelect = val
    },
    addHandleOk () { // 新增保存
      const param = {
        id: "",
        bookId: localStorage.getItem('syzg-bookId'),
        school: "",
        styleId: localStorage.getItem('styleId'),
        paragraphId: "",
        sentenceId: "",
        commentContent: editMess.message,
        viewPermission: this.addSelect, //1：公开 2：私有 3：学校
        rangeType: "5",
        teacherId: this.$getUserInfo().id,
        isPublish: "1"
      }
      this.$fetch({
        url: this.$baseUrl + 'teacher/chapter/saveChapter',
        body: param
      }).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.$message.success('新增成功')
          this.addVisible = false
        }
        this.getData()
      })
    },
    edit (item) { // 编辑弹窗
      this.editMess = ''
      this.editMess = item
      this.id = item.id
      this.editVisible = true
    },
    editSelectChange (val) { // 编辑权限选择
      this.editSelect = val
    },
    textChange (val) {
      this.editMessage = val.target.value
    },
    editHandleOk () {
      const param = {
        id: this.id,
        bookId: localStorage.getItem('syzg-bookId'),
        school: "",
        styleId: localStorage.getItem('styleId'),
        paragraphId: "",
        sentenceId: "",
        commentContent: this.editMessage,
        viewPermission: this.editSelect, //1：公开 2：私有 3：学校
        rangeType: "5",
        teacherId: this.$getUserInfo().id,
        isPublish: "1"
      }
      this.$fetch({
        url: this.$baseUrl + 'teacher/chapter/saveChapter',
        body: param
      }).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.$message.success('编辑成功')
          this.editVisible = false
        }
        this.getData()
      })

    },
    deleted (id) {
      const param = { id: id }
      this.$fetch({
        url: this.$baseUrl + 'teacher/chapter/deleteChapter',
        body: param
      }).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.$message.success('删除成功')
        }
        this.getData()
      })
    },
    goZiYuan () { // 跳转资源推荐
      this.$router.push({ path: '/books/titleRecommend/' })
    },
    goBeiKe () { //跳转备课历史
      this.$router.push({ path: '/books/titleHistory/' })
    }
  }
}
</script>
<style lang="less" scoped>
.main {
  width: 1240px;
  margin: 0 auto;
  margin-top: 30px;
  border-radius: 12px;
  .load {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(50%, 50%);
    z-index: 99;
  }
  .top {
    // height:400px;
    display: flex;
    .left {
      flex: 1;
      border-radius: 12px;
      min-height: 400px;
      .content {
        width: 100%;
        .bgc {
          background: #fff;
          min-height: 350px;
          border-radius: 10px;
          .status {
            padding: 20px 50px 0px 50px;
            .staTitle {
              font-size: 22px;
              color: #bdbdbd;
            }
            .staMain {
              font-size: 22px;
              color: #000;
              margin-left: 30px;
            }
          }
          .message {
            background: #f8f8f8;
            margin: 0 50px;
            color: #000;
            font-size: 18px;
            letter-spacing: 0px;
            padding: 15px 16px;
            line-height: 30px;
            font-weight: normal;
            margin-top: 12px;
          }
        }
      }
    }
  }
  .fun {
    margin: 30px 0px 30px 0px;
    display: flex;
    .button {
      flex: 20;
      .add {
        width: 120px;
        height: 40px;
        color: #a3af90;
        font-size: 16px;
      }
      .edit {
        width: 120px;
        height: 40px;
        color: @primary-color;
        font-size: 16px;
        margin-left: 20px;
      }
      .delete {
        width: 120px;
        height: 40px;
        color: #db5647;
        font-size: 16px;
        float: right;
      }
    }
  }
}
.dalog,
.editdalog {
  padding: 25px;
  .mess {
    width: 1000px;
    height: 150px;
    margin-top: 15px;
    border: 1px solid #e1d9c2;
    background-color: #f8f8f8;
    padding: 20px 30px 0px 30px;
    p {
      color: #000;
      letter-spacing: 0px;
      font-size: 16px;
      line-height: 32px;
    }
  }
  .uploadImg {
    margin-top: 20px;
    .upload {
      width: 100px;
      height: 30px;
      color: #a3af90;
      margin-right: 20px;
    }
  }
}
.sureButton {
  width: 120px;
  height: 30px;
  background: @primary-color;
  color: #fff;
  float: right;
}
/deep/.ant-upload-list-picture .ant-upload-list-item-error,
.ant-upload-list-picture-card .ant-upload-list-item-error {
  border-color: #fff;
}
</style>
